import Layout from "./components/Layout";
import "./App.css";
import AnimatedRoutes from "./components/AnimatedRoutes";
import { SnackbarProvider } from "notistack";
import "@radix-ui/themes/styles.css";
import "../theme-config.css";
import {
  experimental_extendTheme as materialExtendTheme,
  Experimental_CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from "@mui/material/styles";
import {
  CssVarsProvider as JoyCssVarsProvider,
  extendTheme,
} from "@mui/joy/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "./utils/supabase";
import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import { Portal } from "@mui/material";

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const materialTheme = materialExtendTheme({
    typography: {
      fontFamily: [
        "Inter",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 20,
          },
        },
      },
    },
  });

  const joyTheme = extendTheme({
    components: {
      JoySelect: {
        styleOverrides: {
          root: {
            borderRadius: "20px",
          },
          listbox: {
            borderRadius: "15px",
          },
        },
      },
      JoyIconButton: {
        styleOverrides: {
          root: {
            borderRadius: "12px",
          },
        },
      },
      JoyInput: {
        styleOverrides: {
          root: {
            borderRadius: 20,
          },
        },
      },
    },
  });

  useEffect(() => {
    const checkSession = async () => {
      const { data, error } = await supabase.auth.getSession();

      // Check if there is an active session
      if (data.session) {
        if (location.pathname === "/") {
          // If on the login page, navigate to home

          navigate("/home", { replace: true });
        }
      } else {
        if (location.pathname !== "/") {
          // If not on the login page, navigate to login
          enqueueSnackbar("Please sign in to continue", { variant: "info" });
          navigate("/");
        }
      }
    };

    checkSession();
  }, [location.pathname]);

  return (
    <>
      <MaterialCssVarsProvider
        theme={{ [MATERIAL_THEME_ID]: materialTheme }}
        defaultMode="system"
      >
        <JoyCssVarsProvider defaultMode="system" theme={joyTheme}>
          <CssBaseline enableColorScheme />
          <Portal>
            <SnackbarProvider
              anchorOrigin={{ horizontal: "right", vertical: "top" }}
              autoHideDuration={1000}
              preventDuplicate={true}
              style={{
                marginLeft: "auto",
              }}
              classes={{
                containerAnchorOriginTopRight: "w-[350px]",
              }}
            />
          </Portal>

          {location.pathname !== "/" && <Layout />}

          <AnimatedRoutes />
        </JoyCssVarsProvider>
      </MaterialCssVarsProvider>
    </>
  );
}

export default App;
